/*
 * The registrations english translation.
 */
export const REGISTRATION_EN = {
  // RegistrationForm.vue
  minimum: 'Minimum',
  chars: 'Characters',
  confirmPassword: 'Confirm Password',
  passwordRequirementsTitle: 'Password requirements',
  passwordPolicyRequirementLength: 'At least 10 characters',
  passwordPolicyRequirementUppercase: 'At least one uppercase letter',
  passwordPolicyRequirementLowercase: 'At least one lowercase letter',
  passwordPolicyRequirementDigit: 'At least one number',
  passwordPolicyGeneralError:
    'Password must be at least 10 characters and include uppercase, lowercase, and a number.',
  howManyAccountsShouldYourOrgaHaveUpTo: 'How many accounts should your Organisation have? Up to',
  submit: 'Submit',
  // RegisterRadioSelection.vue
  preCustomisedProducts: 'Pre-Customised Products',
  mainProducts: 'Main Products'
}
/*
 * The registrations german translation.
 */
export const REGISTRATION_DE = {
  // RegistrationForm.vue
  minimum: 'Minimum',
  chars: 'Zeichen',
  confirmPassword: 'Passwort bestätigen',
  passwordRequirementsTitle: 'Passwortanforderungen',
  passwordPolicyRequirementLength: 'Mindestens 10 Zeichen',
  passwordPolicyRequirementUppercase: 'Mindestens ein Großbuchstabe',
  passwordPolicyRequirementLowercase: 'Mindestens ein Kleinbuchstabe',
  passwordPolicyRequirementDigit: 'Mindestens eine Zahl',
  passwordPolicyGeneralError:
    'Das Passwort muss mindestens 10 Zeichen lang sein und Großbuchstaben, Kleinbuchstaben sowie eine Zahl enthalten.',
  howManyAccountsShouldYourOrgaHaveUpTo: 'Wie viele Nutzer soll deine Organisation haben? Bis zu',
  submit: 'Absenden',
  // RegisterRadioSelection.vue
  preCustomisedProducts: 'Vorkonfigurierte Produkte',
  mainProducts: 'Hauptprodukte'
}
